import { render, staticRenderFns } from "./FeaturedSelect.vue?vue&type=template&id=2a4627f4&scoped=true"
import script from "./FeaturedSelect.vue?vue&type=script&lang=js"
export * from "./FeaturedSelect.vue?vue&type=script&lang=js"
import style0 from "./FeaturedSelect.vue?vue&type=style&index=0&id=2a4627f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4627f4",
  null
  
)

export default component.exports